import { BadImplementationException } from '@nu-art/ts-common';
import { resolveValueDisplay } from '../../../../_entity/value/index.js';
import { AllInOperators, LogicType_DeltaEquals, LogicType_DeltaGreaterEquals, LogicType_DeltaGreaterThan, LogicType_DeltaLesserEquals, LogicType_DeltaLesserThan, LogicType_DeltaPercentageEquals, LogicType_DeltaPercentageGreaterEquals, LogicType_DeltaPercentageGreaterThan, LogicType_DeltaPercentageLesserEquals, LogicType_DeltaPercentageLesserThan, LogicType_Equals, LogicType_In } from '../../../../_enum.js';
const NumericOperatorConversion = {
    [LogicType_Equals]: '==',
    [LogicType_DeltaPercentageEquals]: '==',
    [LogicType_DeltaEquals]: '==',
    // delta relation operators
    [LogicType_DeltaGreaterEquals]: '>=',
    [LogicType_DeltaLesserEquals]: '<=',
    [LogicType_DeltaGreaterThan]: '>',
    [LogicType_DeltaLesserThan]: '<',
    //delta percent relation operators
    [LogicType_DeltaPercentageGreaterEquals]: '>=',
    [LogicType_DeltaPercentageLesserEquals]: '<=',
    [LogicType_DeltaPercentageLesserThan]: '<',
    [LogicType_DeltaPercentageGreaterThan]: '>',
};
export const resolveRangeEvaluationLogic = (dbAtom, dependencies) => {
    return getCaseRangeType(dbAtom.cases[0]) === 'range' ? resolveInRange(dbAtom) : resolveInImplicitRange(dbAtom, dependencies);
};
const resolveInRange = (dbAtom) => {
    const inRange = {};
    // Set default values derived from the type
    inRange.output_type = 'boolean';
    inRange.type = 'in-range-condition';
    inRange.range_expression = createRangeExpression(dbAtom.cases[0]);
    return inRange;
};
const createInImplicitRangeOption = (_case, option, dependencies) => {
    if (!(_case.rightHand))
        throw new BadImplementationException(`can't convert to range case with empty right hand`);
    const value = dependencies.values.find(value => value._id === _case.rightHand[0]);
    if (!value)
        throw new BadImplementationException(`Cannot find DB Value: ${_case.rightHand[0]}`);
    option.db_id = value._id;
    option.name = resolveValueDisplay(value);
    return option;
};
const resolveInImplicitRange = (dbAtom, dependencies) => {
    const inImplicitRange = {};
    // Set default values derived from the type
    inImplicitRange.output_type = 'boolean';
    inImplicitRange.type = 'in-implicit-range-condition';
    return createInImplicitRangeOption(dbAtom.cases[0], inImplicitRange, dependencies);
};
export const resolveInRangeConversion = (dbAtom, baseConversion, dependencies) => {
    const inRangeConversion = baseConversion;
    inRangeConversion.type = 'in-range-conversion';
    inRangeConversion.options = dbAtom.cases.map(_case => {
        const rangeType = getCaseRangeType(_case);
        const option = {
            return_value: inRangeConversion.output_type === 'tuple' ? _case.value : _case.value[0]
        };
        if (rangeType === 'implicit-range')
            return createInImplicitRangeOption(_case, option, dependencies);
        else
            return { ...option, range_expression: createRangeExpression(_case) };
    });
    return inRangeConversion;
};
const createRangeExpression = (dbAtomCase) => {
    if (!(dbAtomCase.rightHand))
        throw new BadImplementationException(`can't convert to range case with empty right hand`);
    if (AllInOperators.includes(dbAtomCase.caseOperator)) {
        return `${dbAtomCase.rightHand[0]} <= A <= ${dbAtomCase.rightHand[1]}`;
    }
    else if (dbAtomCase.rightHand[0] !== dbAtomCase.rightHand[1])
        throw new BadImplementationException(`When using the " ${dbAtomCase.caseOperator}" operator in an Atom, the right hand value cannot be a range!`);
    const operator = NumericOperatorConversion[dbAtomCase.caseOperator] ?? dbAtomCase.caseOperator;
    return `A ${operator} ${dbAtomCase.rightHand[0]}`;
};
const getCaseRangeType = (_case) => {
    if (_case.caseOperator === LogicType_In) {
        return isRange(_case.rightHand) ? 'range' : 'implicit-range';
    }
    return 'range';
};
const isRange = (value) => {
    return (value?.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number');
};
//# sourceMappingURL=range.js.map